<div class="row">
    <div class="col-12 col-lg-10 col-xl-9">
      <h1 class="mb-5 heading-xl">
		<ng-content select="[headline]"></ng-content>
	  </h1>
      <p class="lead" style="max-width: 75rem;">
        <ng-content></ng-content>
      </p>
    </div>
  </div>